<mat-icon [title]="iconTitle || ''" [svgIcon]="icon?.iconName"></mat-icon>
